import { render, staticRenderFns } from "./officialPayDetail.vue?vue&type=template&id=ffaa8856&scoped=true"
import script from "./officialPayDetail.vue?vue&type=script&lang=js"
export * from "./officialPayDetail.vue?vue&type=script&lang=js"
import style0 from "./officialPayDetail.vue?vue&type=style&index=0&id=ffaa8856&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffaa8856",
  null
  
)

export default component.exports